import Model from "@/lib/model/model";

export class MustComponent extends Model {
  componentSort = 0;
}

export class NonessentialComponent extends Model {
  use = 0;
}
